import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IPurposeOfConnection } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./PurposeOfConnection";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IPurposeOfConnection[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }


    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("PurposeOfConnection", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { purposeOfConnection: IPurposeOfConnection[], count: number } = await response.json();
            setTableData({ data: data.purposeOfConnection, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: { isActive: true } });
    };

    const openEdit = (rowDatauser: IPurposeOfConnection) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const Remove = async (rowData: IPurposeOfConnection) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`PurposeOfConnection/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Status Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IPurposeOfConnection) => {
        confirmDialog({
            message: `Are you sure you want to delete  "${rowData.purposeOfConection}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("PurposeOfConnection", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Purpose Of Connection</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                
            </div>
        </div>
    );

    const actionBodyTemplate = (rowData: IPurposeOfConnection) => {
        return (
            <div className="actions">
                {props.hasPermission("PurposeOfConnection", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("PurposeOfConnection", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>}
            </div>
        );
    };

    const toggleVal = async (id?: number) => {
        const response = await Fetch(`PurposeOfConnection/togglestatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    
    const lostStatusBody = (rowData: IPurposeOfConnection) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }} onClick={() => {  toggleVal(rowData.id) }}></i>
                <span>{rowData.isActive ? 'Active' : 'InActive'}</span>
            </div>
        );
    }

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                 <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="purposeOfConection" header="Purpose Of Connection" sortable />
                <Column field="isActive" header="Status" sortable body={lostStatusBody} />
                <Column field="purpose_description" header="Desc" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}
